import {User} from "../../../../../pages/shared/models/user/user";
import React, {useEffect, useState} from "react";
import {SingleAddress} from "../../../../../pages/user/settings/user-addresses/single-address/single-address";
import {UserAddressesContainer} from "../../../../../pages/user/settings/user-addresses/styled";
import BarekamPagination from "../../../../../pages/orders/my/pagination/barekam-pagination";
import {useAppSelector} from "../../../../../redux/store";
import {UserAddressesResponseModel} from "../../../../../pages/shared/models/api/user-addresses-response.moel";
import userAddressesService from "../../../../../services/user-addresses.service";

const CustomerAddresses = ({customer}: {customer: User | undefined}) => {
    const [addressData, setAddressData] = useState({
        addresses: [],
        totalItems: 0,
        currentPage: 0,
        pageSize: 10
    } as UserAddressesResponseModel);

    const {countries} = useAppSelector(state => state.staticDataReducer);
    const customerCountry = countries.find(country => country.countryId === customer?.locationId.countryId);

    useEffect(() => {
        loadAddresses(addressData.currentPage);
    }, [])

    function loadAddresses(page: number) {
        userAddressesService.getAddresses({relatedUser: customer?.userId}, addressData.pageSize, page)
            .then(response => {
                setAddressData(response);
            })
    }

    function handlePageChange (event: unknown, newPage: number) {
        loadAddresses(newPage - 1);
    }

    return (
        <UserAddressesContainer style={{width: '100%'}}>
                {customerCountry?.warehouse.map(warehouse =>
                    <SingleAddress warehouse={warehouse}
                                   user={customer}
                                   key={`warehouse-` + warehouse.warehouseId}/>
                )}
                {addressData.addresses.map(address =>
                    <SingleAddress address={address}
                                   user={customer}
                                   isReadonly
                                   key={`address-` + address.addressId}/>
                )}

            {addressData.totalItems > addressData.pageSize
                ? <BarekamPagination {...addressData} onPageChange={handlePageChange}/>
                : <></>
            }
        </UserAddressesContainer>
    )

};

export default CustomerAddresses;
